import { GridFilterItem } from '@mui/x-data-grid-pro';

import { httpClient, HttpMethod } from './http-client';
import { QueryOption } from '../@types/common.type';
import { PartTypeListResponse } from '../queries/part-type-query';

export const getAllPartTypes = (queryOptions: QueryOption): Promise<PartTypeListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/partTypes?page=${page + 1}&limit=${pageSize}`;

  if (sortModel && sortModel[0] && sortModel[0].field) {
    url += `&order_by=${sortModel[0].field}&order_direction=${sortModel[0].sort}`;
  }

  filterModel?.items?.forEach((filter: GridFilterItem) => {
    url += `&${filter?.field}=${filter?.operator},${filter.value}`;
  });
  return httpClient<PartTypeListResponse>(url, HttpMethod.Get);
};